<template>
  <div class="component-list">
    <div
      v-if="componentTypesError"
      class="notification is-danger is-light"
      role="alert"
    >
      Could not load component types: {{ componentTypesError }}
      <button
        class="button is-small"
        @click="$store.dispatch('loadComponentTypes')"
      >
        Retry
      </button>
    </div>
    <div class="level mb-3">
      <div class="level-left"><button-group /></div>
      <div class="level-right">
        <button class="button is-primary" @click="openComponentModal()">
          Add component
        </button>
      </div>
    </div>
    <div class="field is-grouped is-grouped-multiline">
      <div class="control">
        <label class="label" for="component-type-filter">Type</label>
        <div class="select">
          <select
            id="component-type-filter"
            :value="componentFilters.type"
            @change="filter({ type: $event.target.value })"
          >
            <option value="">All types</option>
            <option v-for="type in types" :key="type" :value="type">
              {{ type.replaceAll("_", " ") }}
            </option>
          </select>
        </div>
      </div>
      <div class="control">
        <label class="label" for="component-status-filter">Status</label>
        <div class="select">
          <select
            id="component-status-filter"
            :value="componentFilters.status"
            @change="filter({ status: $event.target.value })"
          >
            <option value="">All statuses</option>
            <option v-for="status in statuses" :key="status">
              {{ status }}
            </option>
          </select>
        </div>
      </div>
      <div class="control">
        <label class="label" for="component-inventory-filter"
          >Pro camera ID</label
        ><input
          id="component-inventory-filter"
          class="input"
          type="number"
          min="1"
          :value="componentFilters.inventoryId"
          @change="filter({ inventoryId: $event.target.value })"
        />
      </div>
    </div>
    <div
      v-if="componentListError"
      class="notification is-danger is-light"
      role="alert"
    >
      {{ componentListError }}
      <button class="button is-small" @click="fetchList">Retry</button>
    </div>
    <div class="table-container">
      <table class="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>Type</th>
            <th>Identifier / label</th>
            <th>Manufacturer / model</th>
            <th>Status</th>
            <th>Current Pro Camera</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isLoadingSync">
            <td colspan="6" role="status">Loading components...</td>
          </tr>
          <tr v-else-if="!components.length">
            <td colspan="6" class="has-text-centered py-6">
              No components match your search.
            </td>
          </tr>
          <tr v-for="item in components" v-else :key="item.id">
            <td>{{ item.type.replaceAll("_", " ") }}</td>
            <td>
              {{ item.identifier || "-"
              }}<small class="is-block has-text-grey">{{ item.label }}</small>
            </td>
            <td>
              {{
                [item.manufacturer, item.model].filter(Boolean).join(" / ") ||
                "-"
              }}
            </td>
            <td>
              <span
                :class="[
                  'tag',
                  item.status === 'installed'
                    ? 'is-info'
                    : item.status === 'stock'
                    ? 'is-success'
                    : 'is-warning',
                ]"
                >{{ item.status }}</span
              >
            </td>
            <td>
              <button
                v-if="item.inventory_id"
                class="button is-text is-small"
                @click="
                  openProCameraInventoryModal({
                    id: item.inventory_id,
                    serial_number: item.camera_serial,
                  })
                "
              >
                {{ item.camera_serial || item.inventory_id }}</button
              ><span v-else>-</span>
            </td>
            <td>
              <button
                class="button is-small is-light"
                @click="openComponentModal(item)"
              >
                Details
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ButtonGroup from "@/components/ButtonGroup.vue";
export default {
  name: "ComponentList",
  components: { ButtonGroup },
  data: () => ({
    statuses: ["stock", "installed", "faulty", "repair", "scrapped", "lost"],
  }),
  computed: {
    ...mapState([
      "components",
      "componentFilters",
      "componentRevision",
      "componentListError",
      "isLoadingSync",
      "componentTypes",
      "componentTypesError",
    ]),
    types() {
      return this.componentTypes;
    },
  },
  watch: {
    componentRevision() {
      this.fetchList();
    },
  },
  methods: {
    ...mapActions([
      "fetchList",
      "openComponentModal",
      "openProCameraInventoryModal",
    ]),
    openProCameraInventoryModal(item) {
      this.$store.dispatch("openComponentCamera", {
        inventory_id: item.id,
        camera_serial: item.serial_number,
      });
    },
    filter(value) {
      this.$store.commit("SET_COMPONENT_FILTERS", value);
      this.$store.commit("SET_CURRENT_PAGE", {
        tabIndex: this.$store.getters.activeTabIndex,
        page: 1,
      });
      this.fetchList();
    },
  },
  mounted() {
    this.$store.dispatch("loadComponentTypes");
    this.fetchList();
  },
};
</script>
